import { useLocale, useTranslations } from 'next-intl'
import { ComponentType } from 'react'

import { cn } from '@/shared/lib'
import { Carousel } from '@/shared/ui'

import EasySearch from '../../asset/easy-search.svg'
import ReasonableCost from '../../asset/reasonable-cost.svg'
import SecureContract from '../../asset/secure-contract.svg'
import WeeklyRental from '../../asset/weekly-rental.svg'

export const Features = () => {
  const t = useTranslations('main.intro')

  const FEATURES = [
    {
      id: 1,
      title: t('card_reasonable.title'),
      description: t('card_reasonable.description'),
      Icon: ReasonableCost,
    },
    {
      id: 2,
      title: t('card_safe.title'),
      description: t('card_safe.description'),
      Icon: SecureContract,
    },
    {
      id: 3,
      title: t('card_convenient.title'),
      description: t('card_convenient.description'),
      Icon: EasySearch,
    },
    {
      id: 4,
      title: t('card_weekly_rental.title'),
      description: t('card_weekly_rental.description'),
      Icon: WeeklyRental,
    },
  ]

  return (
    <Carousel.Provider orientation="horizontal" useAutoPlay>
      <Carousel.Root className="w-screen">
        <Carousel.Content className="ml-0 p-6">
          {FEATURES.map(({ id, title, description, Icon }) => (
            <Carousel.Item
              key={id}
              className={cn('basis-auto space-y-4.5 pr-3.5 pl-0 last:pr-6')}
            >
              <Feature
                id={id}
                title={title}
                description={description}
                Icon={Icon}
              />
            </Carousel.Item>
          ))}
        </Carousel.Content>
      </Carousel.Root>
    </Carousel.Provider>
  )
}

type FeatureProps = {
  id: number
  title: string
  description: string
  Icon: ComponentType<{ size: number }>
}

const Feature = ({ id, title, description, Icon }: FeatureProps) => {
  const locale = useLocale()

  return (
    <div
      className={cn(
        'h-[208px] w-[210px] rounded-lg bg-white p-5 pb-6 shadow-[0_0_18px_0_rgba(0,0,0,0.10)]',
        locale === 'en' && 'w-[230px]',
      )}
    >
      <div className="mb-4.5 flex justify-between">
        <span className="typo-title1 relative -top-[7px] font-bold text-[#DADADA]">
          {id}
        </span>
        <Icon size={64} />
      </div>
      <h3 className="typo-headline2 mb-3 font-semibold text-black">{title}</h3>
      <p className="typo-label1 font-normal whitespace-break-spaces text-gray-600">
        {description}
      </p>
    </div>
  )
}
